// @flow weak

import memoize from 'memoize-weak';
import { get, isNil, map } from 'lodash';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';
import * as SSOIdentity from 'app/entities/SSOIdentity';
import * as Subscription from 'app/entities/Subscription';
import { SSOIdentityProviders } from 'app/settings/utils/constants';
import { emptyObject } from 'app/common/CommonUtils';
import { getIntegerParam } from 'app/common/utils/RouterSelectors';

export const fieldsToValueObject = (selectorFn: Object => Object) =>
  memoize((fields, state) => {
    const entity = selectorFn(state);
    return fields.reduce(
      (value, field) => ({
        [field.key]: field.selectValue && field.selectValue(entity),
        ...value,
      }),
      {}
    );
  });

export const isProfileSaving = state =>
  Profile.selectors.isSaving(Profile.selectors.all.currentProfile(state));

export const isSubscriptionSaving = state =>
  Subscription.selectors.all.isSaving(state);

export const isAccountSaving = state => {
  const accountId =
    getIntegerParam('accountId', state) ||
    Account.selectors.all.currentAccountId(state);
  const currentAccount = Account.selectors.all.entity(accountId, state);
  return Account.selectors.isSaving(currentAccount);
};

export const hasBillingAccess = state => {
  const accountId =
    getIntegerParam('accountId', state) ||
    Account.selectors.all.currentAccountId(state);
  return Profile.selectors.all.isAdminOf(accountId, state);
};

export const getSettingsTitle = state =>
  get(state, ['router', 'current', 'title'])
    ? `${state.router.current.title} - Settings`
    : 'Settings';

export const getZapRunStatusMap = state =>
  get(state, ['dashboard', 'zapRunStatusMap'], emptyObject);

export const getSSOIdentities = state =>
  map(SSOIdentityProviders, provider => {
    const ssoIdentityItem = SSOIdentity.selectors.all.findByProvider(
      provider,
      state
    );
    const errorMessage = SSOIdentity.selectors.isFailure(ssoIdentityItem)
      ? SSOIdentity.selectors.statusMessage(ssoIdentityItem)
      : '';
    const ssoIdentity: Object = isNil(ssoIdentityItem)
      ? { provider }
      : {
          errorMessage,
          ...SSOIdentity.selectors.data(ssoIdentityItem),
        };

    return {
      ...ssoIdentity,
      isConnected: !isNil(ssoIdentity.id),
    };
  });

export const selectIsConfirmingDataDeletion = state =>
  state.settings.confirmingDataDeletion;
